import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import styled from 'styled-components';
import { colors, fonts } from '../../../../utils';

const {
	secondaryBackground,
	primaryText,
	colorWhite,
	colorDimBlack,
	colorText,
	colorLightBlack,
	colorPrimary,
} = colors;

const { primaryFont } = fonts;

// utlity classes
export const Flex = styled.div`
	display: flex;
	justify-content: ${(props) => (props.jc ? props.js : 'flex-start')};
	align-items: ${(props) => (props.ai ? props.ai : 'center')};
	gap: ${(props) => props.gap && props.gap};
`;

export const Sidebar = styled.div`
	width: 100%;
	max-width: ${(props) => (props.maxWidth ? props.maxWidth : '25rem')};
	position: fixed;
	height: 98vh;
	background-color: ${colorDimBlack};
	padding: 1.5rem 1.5rem;
	margin: 1rem;
	margin-top: 0;
	margin-bottom: 0;
	border-radius: 1.5rem;
	transition: all 0.2s ease-in;
	overflow-y: auto;
	z-index: 1111 !important;

	&::-webkit-scrollbar-track {
		// eslint-disable-next-line no-confusing-arrow
		/* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
		background-color: transparent !important;
	}

	&::-webkit-scrollbar {
		display: none;
		background-color: transparent !important;
		width: 6px !important;
		height: 30px !important;
		border-radius: 3px !important;
		transform: rotate(-180deg) !important;
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
		background-color: ${secondaryBackground} !important;
	}

	@media screen and (max-width: 500px) {
		max-width: ${(props) => (props.maxWidth ? props.maxWidth : '22rem')};
	}
`;

export const SidebarHeader = styled.div`
	display: flex;
	justify-content: ${(props) => (props.jc ? props.js : 'space-between')};
	align-items: center;
`;

export const SidebarLogo = styled.div`
	cursor: pointer;
	visibility: ${(props) => (props.visibility ? props.visibility : 'visible')};
	transition: visibility 0.16s ease-in-out;

	& img {
		width: max-content;
		height: 8rem;
		width: 8rem;
	}

	@media screen and (max-width: 768px) {
		& img {
			height: 3rem;
			margin-left: -2rem;
		}
	}
`;

export const ClickOnHover = styled.div`
	width: 3rem;
	height: 3rem;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;

	&:hover {
		border: 1px solid ${colorWhite};
	}
`;

export const ToggleMenu = styled.div`
	cursor: pointer;
`;

export const MainMenu = styled.ul`
	margin-top: 1.5rem;
	margin-left: ${(props) => (props.ml ? props.ml : '0')};
	transition: 0.2s all ease-in;
	overflow-y: auto;
	height: 70vh;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const MainMenuList = styled.li`
	margin: 1.5rem 0;
	position: relative;
`;

export const MainMenuListLink = styled.div`
	display: flex;
	justify-content: ${(props) => (props.jc ? props.jc : 'flex-start')};
	align-items: center;
	margin-bottom:1rem;
	font-size: 1.6rem;
	width: 100%;
	cursor: pointer;
	color: ${primaryText};
`;

export const MainMenuListIcon = styled.div`
	margin-top: 0.2rem;
`;

export const MainMenuListLabel = styled.p`
	margin-left: 1rem;
	font-size: 1.5rem;
`;

export const SubMenu = styled.ul`
	margin-left: 2rem;
	padding-left: 1rem;
	margin-top: 0.5rem;
`;

export const SubMenuList = styled.li`
	margin: 1rem 0;
`;

export const SubMenuListLink = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;

export const SubMenuListIcon = styled.div`
	margin-right: 1rem;

	img {
		width: 18px;
		height: 18px;
	}

	@media screen and (max-width: 400px) {
		width: 15px;
		height: 15px;
	}
`;

export const SubMenuListLabel = styled.p`
	font-size: 1.4rem;
	color: ${colorText};
	letter-spacing: 0.03em;
	display: inline-block;

	@media screen and (max-width: 400px) {
		font-size: 1.1rem;
	}
`;

// responsive menu list
export const ResSubMenu = styled.div`
	position: absolute;
	top: 0;
	left: 10px;
	background-color: #333;
	width: 300px;
	z-index: 1111 !important;
`;

export const ResSubMenuList = styled.div`
	padding: 1rem;
`;

export const SidebarFooter = styled.div`
	background-color: ${colorLightBlack};
	color: ${colorWhite};
	position: absolute;
	bottom: 0;
	left: 0;
	height: 6rem;
	width: 100%;
	padding: 1rem 1.2rem;
	display: flex;
	justify-content: center;
`;

export const FooterUserImg = styled.div`
	width: 3.3rem;
	height: 3.3rem;

	img {
		background-color: ${colorWhite};
		border-radius: 50%;
	}
`;

export const ToggleBtnGroup = styled(ToggleButtonGroup)`
	width: 100%;
	background: ${colorDimBlack};
`;

export const ToggleBtn = styled(ToggleButton)({
	color: `${colorWhite} !important`,
	padding: '0.9rem 1rem !important',
	marginRight: '1rem !important',
	textTransform: 'none !important',
	fontSize: '1.4rem !important',
	fontFamily: `${primaryFont} !important`,

	'&.Mui-selected, &.Mui-selected:hover': {
		color: `${colorWhite} !important`,
		backgroundColor: `${colorPrimary} !important`,
		padding: '0.9rem 1rem !important',
	},
});
